var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{ref:"svg_wrapper",staticClass:"svg-img",class:{'cursor-pointer': _vm.auto_hover},on:{"mouseenter":function($event){_vm.hovering = true},"mouseleave":function($event){_vm.hovering = false},"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }